import {gql} from 'apollo-angular';

export const GET_ROOKIE_DAY_STUDENT = gql`
  query GetRookieDayStudent($code: String!, $verifyCode: String!) {
    rookiedayStudent(code: $code, verifyCode: $verifyCode) {
      id
      firstname
      lastname
    }
  }
`;
